var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnectWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 60,
    viewBox: "0 0 456 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1654_7953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6185 0L20.2659 39.8077H10L49.3526 0",
    fill: "#BCBBBE",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.629 0L369.277 39.8077H359.011L398.363 0",
    fill: "#BCBBBE",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8695 0.192688L38.5169 40.0004H28.251L67.6036 0.192688",
    fill: "#BCBBBE",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.879 0.192688L387.527 40.0004H377.261L416.613 0.192688",
    fill: "#BCBBBE",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1195 0.192688L56.7669 40.0004H46.501L85.8536 0.192688",
    fill: "#BCBBBE",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.13 0.192688L405.778 40.0004H395.512L434.864 0.192688",
    fill: "#BCBBBE",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.93 0.192688L359.577 40.0004H56.459L95.8116 0.192688",
    fill: "url(#paint0_linear_1654_7953)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1654_7953",
    x: -10,
    y: 0,
    width: 469,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.991667 0 0 0 0 0.860963 0 0 0 0 0.174768 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1654_7953"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1654_7953",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1654_7953",
    x1: 33.796,
    y1: 40.1195,
    x2: 600.372,
    y2: 40.0032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341688,
    stopColor: "#7C7853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.650942,
    stopColor: "#787878"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWallet);
export default __webpack_public_path__ + "static/media/connect-wallet.113d1d283d05571a4025909b56fe38ff.svg";
export { ForwardRef as ReactComponent };